const state = {
  user: null,
  tabStorage: false,
  token: "",
  toolBarData: [], // 保存标签button的数组
  cacheView: [], // 保存需要缓存的数组
  orderCount: {},
};

export default state;
